<style lang="scss" scoped>
::v-deep .dropdown-link {
    & > a {
        display: none;
    }

    .dropdown {
        opacity: 1;
        position: relative;
        top: unset;
        right: unset;
        pointer-events: all;
        padding: 0;

        .dropdown-inner {
            border-radius: 0;
            background-color: unset;
            box-shadow: none;
            min-width: 0;
            padding: 0;
        }
    }
}
</style>

<template>
    <div class="md:px-80 slideout-menu py-60 md:py-120 flex flex-col items-start px-20">
        <div class="lg:hidden flex flex-col items-start mb-32">
            <slot></slot>
        </div>

        <div class="lg:hidden" v-if="generalData">
            <search-bar class="mb-32" :placeholder="generalData.menu_data.search_placeholder" :open="true">
                <div class="text-blue mr-16">
                    <span v-html="svg('search', 'fill-current ')"></span>
                </div>
            </search-bar>
        </div>

        <div class="md:mb-80 flex flex-col items-start mb-32" v-if="menu">
            <template v-for="(item, index) in menu">
                <a :key="index" v-if="item.page != null && item.show_in_menu" class="text-20 last:mb-0 mb-16 font-bold" :href="`${item.page.relative_link}`" v-html="item.name"></a>
            </template>
        </div>
        <div class="flex flex-col items-start" v-if="generalData">
            <a class="opacity-70 hover:opacity-100 flex items-center mb-16 text-gray-800" :href="`mailto:${generalData.contact_email}`">
                <span v-html="svg('mail', 'fill-current mr-8 w-14 h-14 mt-1')"></span>
                {{ generalData.contact_email }}
            </a>
            <a class="opacity-70 hover:opacity-100 flex items-center mb-16 text-gray-800" href="/info">
                <span v-html="svg('headphones', 'fill-current mr-8 w-14 h-14 mt-1')"></span>
                {{ generalData.menu_data.customer_service_label }}
            </a>
            <a class="opacity-70 hover:opacity-100 flex items-center text-gray-800" :href="generalData.facebook_url" target="_blank" rel="noopener">
                <span v-html="svg('facebook', 'fill-current mr-8 w-14 h-14 mt-1')"></span>
                {{ generalData.menu_data.facebook_label }}
            </a>
        </div>
    </div>
</template>

<script>
export default {
    name: "Ui.SlideoutMenu",

    data() {
        return {
            generalData: null,
            menu: []
        };
    },

    mounted() {
        this.loadMenu();
        this.loadTranslations();
    },

    methods: {
        loadMenu() {
            const self = this;
            return new Promise(function(resolve, reject) {
                axios
                    .get("/api/menu")
                    .then(function(response) {
                        self.menu = response.data;
                        resolve(response.data);
                    })
                    .catch(function(error) {
                        reject(error);
                    });
            });
        },

        loadTranslations() {
            const self = this;
            return new Promise(function(resolve, reject) {
                axios
                    .get("/api/general")
                    .then(function(response) {
                        self.generalData = response.data;
                        resolve(response.data);
                    })
                    .catch(function(error) {
                        reject(error);
                    });
            });
        }
    }
};
</script>
